import React from 'react';
import jalaliMoment from 'jalali-moment';
import Typography from '@material-ui/core/Typography';


export default class DateAndTime extends React.Component{
    constructor(props){
        super(props);
        this.state={
            date : jalaliMoment()
        }
    }
    componentDidMount = () =>{
        setInterval(()=>{
            this.setState({date: jalaliMoment()})

        },1000);
    }
    render= ()=> { 
            return(
                <div className="text-light">
                    <Typography variant="h2" align="center" >
                        {this.state.date.format("HH:mm")}
                    </Typography>
                        <Typography align="center" fontWeight="light" fontSize=".875rem"  >
                        {this.state.date.locale("fa").format("dddd, DD MMMM ")}
                        </Typography>
                    
                </div>
            );
    }
}